<script setup lang="ts">
import { legalCompany as c } from '~/content/legal'
</script>

<template>
    <LegalPage title="Politique de cookies"
        description="Informations sur l’utilisation des cookies et traceurs sur le site Deboosere Chauffage Sanitaire.">
        <h2>1. Qu’est-ce qu’un cookie ?</h2>
        <p>
            Un cookie (ou traceur) est un petit fichier déposé ou lu sur votre terminal (ordinateur, smartphone,
            tablette) lors de la consultation d’un site. Il permet, par exemple, de mémoriser des préférences ou de
            mesurer l’audience.
        </p>

        <h2>2. Les cookies utilisés sur ce site</h2>
        <div class="legal-box">
            <p class="!mb-0">
                <strong>Ce site ne dépose aucun cookie publicitaire, de mesure d’audience ou de réseau social.</strong>
                Aucun outil de suivi (Google Analytics, pixel Facebook, etc.) n’y est installé.
            </p>
        </div>
        <p>
            Seuls peuvent être utilisés des traceurs strictement nécessaires au fonctionnement du site et à sa
            sécurité (par exemple la protection anti-spam du formulaire de contact). Conformément à l’article 82 de
            la loi Informatique et Libertés et aux lignes directrices de la CNIL, ces traceurs sont exemptés de
            consentement. C’est pourquoi aucun bandeau de consentement ne vous est présenté.
        </p>

        <h2>3. Contenus provenant de services tiers</h2>
        <p>Certaines fonctionnalités font appel à des services externes :</p>
        <ul>
            <li>
                <strong>Avis Google</strong> : les photos de profil des auteurs d’avis sont chargées depuis les
                serveurs de Google (googleusercontent.com). Notre site ne dépose pas de cookie à cette occasion,
                mais Google reçoit votre adresse IP ;
            </li>
            <li>
                <strong>Suggestion d’adresses (Photon / komoot)</strong> : utilisée uniquement lorsque vous saisissez
                un lieu d’intervention dans le formulaire, sans dépôt de cookie.
            </li>
        </ul>
        <p>
            Les polices de caractères sont hébergées directement sur notre serveur : aucune requête n’est envoyée à
            Google Fonts.
        </p>

        <h2>4. Liens vers les réseaux sociaux</h2>
        <p>
            Le lien vers notre page Facebook est un simple lien hypertexte : aucun module Facebook n’est chargé et
            aucun cookie Facebook n’est déposé tant que vous ne cliquez pas dessus. Une fois sur Facebook, c’est la
            politique de cookies de ce réseau qui s’applique.
        </p>

        <h2>5. Paramétrer votre navigateur</h2>
        <p>
            Vous pouvez à tout moment configurer votre navigateur pour bloquer ou supprimer les cookies. Consultez
            l’aide de votre navigateur :
        </p>
        <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/fr/kb/protection-renforcee-contre-pistage-firefox-ordinateur" target="_blank" rel="noopener">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener">Safari</a></li>
            <li><a href="https://support.microsoft.com/fr-fr/microsoft-edge/supprimer-les-cookies-dans-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener">Microsoft Edge</a></li>
        </ul>

        <h2>6. Évolution</h2>
        <p>
            Si des outils de mesure d’audience ou d’autres traceurs soumis à consentement venaient à être ajoutés,
            votre accord préalable serait recueilli via un bandeau vous permettant d’accepter ou de refuser aussi
            simplement, et cette politique serait mise à jour.
        </p>

        <h2>7. Contact</h2>
        <p>
            Pour toute question : <a :href="c.phoneHref">{{ c.phone }}</a>. Pour en savoir plus sur
            vos données, consultez notre
            <NuxtLink to="/politique-de-confidentialite">politique de confidentialité</NuxtLink>.
        </p>
    </LegalPage>
</template>
